import React, { Component } from 'react'
import PropTypes from 'prop-types'
import actions from 'redux/actions'
import { startCase } from 'lodash'
import { formatPrice, mixpanel, constants, snowplow } from 'common/helpers'
import { FormattedHTMLMessage } from 'sb-react-intl'

import injectGlobals from 'decorators/injectGlobals'
import Button from 'components/buttons/Button/Button'
import Modal from 'components/modal/Modal/Modal'

import messages from './messages'
import s from './ProlongOfferModal.scss'


const abOffers = [
  'FINANCIAL_COMMITMENT', 'MANY_PERFUMES', 'TOO_EXPENSIVE', 'FINANCIAL_VALUE',
]

const DEFAULT_PRICE   = 1495
const DISCOUNT        = 500

const DISCOUNT_LABEL = '$5'

// months to month price map
const discountPrices = {
  1: 750,
  3: 1250,
  5: 1350,
}

// rounding prices to avoid printing $1.49 instead of $1.50
const round         = (number) => Math.round(number / 10) * 10
const formatCents   = (number) => formatPrice(number, true)


class ProlongOfferModal extends Component {

  static propTypes = {
    name: PropTypes.string.isRequired,
  }

  static defaultProps = {
    name: constants.modals.cancelSubscription.ProlongOffer,
  }

  constructor(props) {
    const { data: { reason }, unsubscribeProlongedAbValue } = props

    super()

    let offerMonthsCount  = 1
    let discountLabel
    let discountPrice

    const isUnsubscribeProlongedAbApplicable = abOffers.includes(reason)

    if (isUnsubscribeProlongedAbApplicable) {
      if (unsubscribeProlongedAbValue === 'b') {
        offerMonthsCount  = 3
      }
      else if (unsubscribeProlongedAbValue === 'c') {
        offerMonthsCount  = 5
      }

      discountLabel = formatCents(round(DEFAULT_PRICE - discountPrices[offerMonthsCount]))
      discountPrice = formatCents(discountPrices[offerMonthsCount])
    }

    this.state = {
      reasonValue: startCase(reason),
      defaultPrice: formatCents(DEFAULT_PRICE),
      discountPrice: discountPrice || formatCents(round(DEFAULT_PRICE - DISCOUNT)), // TODO round? 14.95 - 5 != 10
      discountLabel: discountLabel || DISCOUNT_LABEL,
      offerMonthsCount,
      isUnsubscribeProlongedAbApplicable,
    }
  }

  componentDidMount() {
    const { reasonValue } = this.state

    mixpanel.track(constants.analyticsEvents.stopUnsubscribePopup, {
      type: reasonValue,
    })

    actions.models.ui.setClosedPopup('prolongOfferModal')
  }

  continueCancellation = () => {
    const { data } = this.props

    actions.models.subscription.unsubscribe(data)
      .then(({ isRefundAvailable, refund }) => {
        this.close()

        if (isRefundAvailable || refund) {
          actions.models.modals.open(constants.modals.cancelSubscription.Refund, refund)
        }
        else {
          actions.models.modals.open(constants.modals.cancelSubscription.SubscriptionWasCancelled)
        }
      })
  }

  close = () => {
    const { name } = this.props

    actions.models.modals.close(name)
  }

  trackCloseModal = (action) => {
    const { defaultPrice, discountPrice: stringDefaultPrice, offerMonthsCount } = this.state
    const discountPrice = parseFloat(stringDefaultPrice.replace('$', ''))

    snowplow.track(constants.snowplowEvents.cancelSubscriptionStepComplete, {
      stepName: 'prolong offer',
      action,
      defaultPrice,
      discountPrice,
      monthCount: offerMonthsCount,
    }, false)
  }

  handleAcceptOffer = () => {
    const { offerMonthsCount, reasonValue, discountLabel, isUnsubscribeProlongedAbApplicable } = this.state

    let couponCode = constants.resubscribeTypes.resub10reason

    if (isUnsubscribeProlongedAbApplicable) {
      couponCode = offerMonthsCount === 1
        ? constants.resubscribeTypes.resub50
        : constants.resubscribeTypes[`resub${offerMonthsCount}month`]
    }

    mixpanel.track(constants.analyticsEvents.stopUnsubscribe, {
      type: reasonValue,
    })

    this.trackCloseModal('accept discount')

    actions.models.ui.showRequestLoader()
    actions.models.subscription.applyCoupon(couponCode)
      .then(() => {
        this.close()
        actions.models.modals.open(constants.modals.cancelSubscription.ProlongThankYou, {
          discountLabel,
          monthsCount: offerMonthsCount,
        })
      }, () => this.close())
      .finally(() => actions.models.ui.hideRequestLoader())
  }

  handleCloseModal = () => {
    this.trackCloseModal('close')
  }

  render() {
    const { offerMonthsCount, discountPrice, discountLabel, defaultPrice, isUnsubscribeProlongedAbApplicable } = this.state
    const { name } = this.props

    const values = {
      monthsCount: offerMonthsCount,
      discount: discountLabel,
      discountPrice,
      defaultPrice,
    }

    const buttonLabel = isUnsubscribeProlongedAbApplicable ? messages.nextMonthButtonLabel : messages.discountButtonLabel

    return (
      <Modal
        name={name}
        title={{
          ...(isUnsubscribeProlongedAbApplicable ? messages.nextMonthTitle : messages.discountTitle),
          values,
        }}
        onClose={this.handleCloseModal}
      >
        <FormattedHTMLMessage tag="div" {...messages.text} values={values} />
        <Button
          className={s.button}
          brand
          noPadding
          title={{ ...buttonLabel, values }}
          onClick={this.handleAcceptOffer}
        />
        <Button
          className={s.button}
          gray
          noPadding
          title={messages.cancelSubscription}
          onClick={this.continueCancellation}
        />
      </Modal>
    )
  }
}


export default injectGlobals(({ getAbValue }) => ({
  unsubscribeProlongedAbValue: getAbValue(constants.abTests.unsubscribeProlonged),
}))(ProlongOfferModal)
